import React, { Component, Fragment } from "react";
import { cloneDeep, debounce, has, last, values } from "lodash";
import { Col, Form, Input, InputNumber, Modal, Row, Select, Button, Tabs, message, Switch} from "antd";
import {
  BankOutlined,
  BarcodeOutlined,
  FundViewOutlined,
  UserOutlined,
  DollarCircleOutlined,
} from "@ant-design/icons";
import Resources from "../scripts/resources";
import Rules from "../scripts/rules";
import API from "../scripts/api";
import { Upload, Image } from 'antd';
import {PlusOutlined, ProjectOutlined, DeleteOutlined} from '@ant-design/icons';
import {Constants} from "../scripts/settings";
import TextArea from "antd/lib/input/TextArea";
import { Cookies } from "react-cookie";
const _cookies = new Cookies();

const getBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
class ProductForm extends Component {

  constructor(props) {
      super(props);

      this.state = {
          activeTab: "1",
          data: {},
          subCats: [],
          mainCats: [],
          category_type: "",
          imageGallery: [],
          imageGalleryData: [],
          searchProducts: [],
          sub_list_type_options: [
            {value: "color", label: "color"},
            {value: "size", label: "size"},
            {value: "brand", label: "brand"},
          ],
          previewOpen: false,
          previewImage: "",
          fileList: []
      };

      this.formRef = React.createRef();

  }

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  }
  handleDidMount =async (data = {}) => {
      const cloneData = cloneDeep(data);
      this.setState({selected: data})
     let baseCategoryId = ""
    let subCategoryId = ""
  
        if (data._id){
          if (data.id_categories[0]?._id != undefined)
            baseCategoryId = data.id_categories[0]._id
  
  
          if (data?.id_categories[1] != undefined)
            subCategoryId = data.id_categories[1]._id
          cloneData.category = baseCategoryId
          cloneData.subCategory = subCategoryId
          console.log("data", data)
  
          await this.getSubCategories(baseCategoryId)
        }
        let selectedValues = []
        let subProductOptions = []
        if(data.related_products){
          await Promise.all(await data.related_products.map(async tempItem => {
            subProductOptions.push({
              label: tempItem.title,
              value: tempItem._id
            })
            selectedValues.push(tempItem._id)
          }))
        }
        let images = []
        if(data.id_stores){
          await Promise.all(await data.id_stores.map(async tempItem => {
            await images.push({
                uid: tempItem._id,
                name: tempItem.location,
                status: 'done',
                url: Constants.imagePathProduct + tempItem.location,
            })
          }))
        }
        this.setState({ 
           selectedValues:  selectedValues,  
          subProductOptions: subProductOptions,
          fileList: images
        });

  
        cloneData.related_products = selectedValues
        if(this.formRef.current)
          this.formRef.current.setFieldsValue(cloneData);

  };

  handleWillUnmount = () => {
      // this.formRef.current.resetFields();
      // map.remove()
  };

  getSubCategories = (value) => {
    API.category.list({parentId: value, type: "sub", category_type: this.state.category_type})
        .then((result) => {
          if (result) {
            this.setState({
              loading: false,
              subCats: result.data
            });
          } else {
            this.setState({ loading: false } );
          }
        })
        .catch(() => {
          this.setState({ loading: false });
        });


};
  render() {
      const {onCancel, submitting, visible, mainCats, onSubmit} = this.props;
      const {editMode, activeTab, loading, subProductOptions, selectedValues,
        subCats, selected, sub_list_type_options, imageGallery, fileList, previewImage, previewOpen
      } = this.state;


      const props = {
        name: 'file',
        action: `${Constants.baseUrl}/store`,
        headers: {
          authorization: `Bearer ${ _cookies.get("AccessToken") || ""}`,
          'Access-Control-Allow-Origin': '*'
        },
        
      }
            
        // const uploadButton = (
        //             <div>
        //               <PlusOutlined />
        //               <div style={{ marginTop: 8 }}>{Resources.addNewImage}</div>
        //             </div>
        // );

        const searchSubProducts = debounce(async (searchText) => {
             API.product.searchSubList(this.state.selected._id, {q: searchText, page: 1})
               .then(async (result) => {
                 let listTemp = []
                 await result.data.map((item) =>
                   listTemp.push( {
                     label: item.title,
                     value: item._id
                   })
                 )
             this.setState({subProductOptions: listTemp})
           })
           .catch(() => {
             this.setState({ submitting: false });
           });
         }, 500); // debounce to avoid too many requests
             
       const setSelectedValues= (val) => {
         console.log(val)
       }
        const onFinish = async () => {
          await this.formRef.current.validateFields().then( async values => {
            console.log("Success:", values);
            values.discount = parseInt(values?.discount)
            let id_categories = []
            if (values.category){
              id_categories.push( values.category)
            }
            if (values.subCategory){
              id_categories.push( values.subCategory)
            }
            values.id_stores = fileList.map(file => (isValidMongoId(file.uid)) ? file.uid : file?.response?.path?._id);
            values.id_categories = id_categories
            await API.product
            .update(values, this.state.selected._id)
            .then((result) => {
              message.success(result.message);
              this.setState({ submitting: false });
              this.formRef.current.resetFields();
              onCancel()
            })
            .catch(() => {
              this.setState({ submitting: false });
            });
        });
      };
      function isValidMongoId(id) {
        return /^[0-9a-fA-F]{24}$/.test(id);
      }
       
      const handlePreview = async file => {
        if (!file.url && !file.preview) {
          file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
      };
      const handleChange = ({ fileList: newFileList }) => setFileList(fileList, newFileList);
      const uploadButton = (
        <button style={{ border: 0, background: 'none' }} type="button">
          <PlusOutlined />
          <div style={{ marginTop: 8 }}>Upload</div>
        </button>
      );

      const setPreviewOpen = (val) => {
        this.setState({previewOpen : val})
      }

      const setPreviewImage = (val) => {
        this.setState({previewImage : val})
      }

      const setFileList = async(fileList, newFileList) => {

        await Promise.all(await fileList.map(async tempItem => {
          const HasItem = await newFileList.find(u => u.uid === tempItem.uid)
          if(!HasItem){
            if(isValidMongoId(tempItem.uid)){
              await API.store.delete(tempItem.uid)
            }
          }
            
        }))
        this.setState({fileList : newFileList})
      }
      return (
          <Fragment>
              <Modal
                  // title={t("details")}
                  visible={visible}
                  onOk={onFinish}
                  onCancel={onCancel}
                  okText={Resources.confirm}
                  // okButtonProps={{ style: { display: 'none' } }}
                  cancelText={Resources.cancel}
                  okButtonProps={{loading: submitting}}
                  cancelButtonProps={{disabled: submitting}}
                  width={1200}
                  // footer={null}
                  // closable={false}
                  bodyStyle={{overflowX: 'scroll'}}
                  style={{ height: 'calc(100vh - 150px)' }}
              >
                 
                  <div className="ant-content">
                     

                    <Form ref={this.formRef} layout="vertical" >
                      <div style={{ height: "100vh" }}>
                        <Row style={{ height: "100%" }}>
                          <Col md={16} xs={24} style={{  padding: 20 }} className="custom-row-border">
                            <Row gutter={24}>
                                  <Col xs={12}>
                                    <Form.Item
                                      name="title"
                                      label={`${Resources.title}`}
                                      rules={Rules.required}
                                    >
                                      <Input type="text"   />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={12}>
                                    <Form.Item
                                      name="sub_title"
                                      label={`${Resources.sub_title} `}
                                    >
                                      <Input type="text"  />
                                    </Form.Item>
                                  </Col>
                      
                                  <Col xs={24}>
                                    <Form.Item
                                      name="description"
                                      label={`${Resources.description} `}
                                    >
                                      <TextArea type="text"   />
                                    </Form.Item>
                                  </Col>
                            </Row>

                            <Row gutter={24} className="custom-row-border" style={{minHeight: "400px"}}>
                                        
                              <Tabs
                                activeKey={activeTab}
                                type="card"
                                onTabClick={this.handleTabChange}
                                tabPosition="right"
                              >

                                {/* generalInformation  */}
                                <Tabs.TabPane tab={Resources.generalInformation} key="1"  >
                                  <Row gutter={24}>
                                
                                    <Col xs={24} md={12}>
                                      <Form.Item
                                        name="price"
                                        label={`${Resources.price} ${Resources.base} (${Resources.toman})`}
                                        rules={Rules.required}
                                      >
                                        <Input
                                          type="number"
                                          prefix={<DollarCircleOutlined />}
                                          dir="ltr"
                                        />
                                      </Form.Item>
                                    </Col>

                                    <Col xs={24} md={12}>
                                      <Form.Item
                                          name="discount"
                                          label={`${Resources.discount} (${Resources.percentage})`}
                                      >
                                        <Input
                                            type="number"
                                            prefix={<DollarCircleOutlined />}
                                            dir="ltr"
                                        />
                                      </Form.Item>
                                    </Col>

                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            name="score"
                                            label={`${Resources.productScore}`}
                                        >
                                          <Input
                                              type="number"
                                              dir="ltr"
                                          />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            name="custom_label"
                                            label={`${Resources.customLabel}`}
                                        >
                                          <Input
                                              type="text"
                                          />
                                        </Form.Item>
                                    </Col>

                                  

                               
                                    
                            
                                    <hr />
                                    <Col xs={24} md={24}>
                                          <Form.Item name="is_publish" label={Resources.confirmToPublish} valuePropName={selected?.is_publish ? "checked" : ""}   >
                                            <Switch  />
                                          </Form.Item>
                                    </Col>

                                  </Row>
                                </Tabs.TabPane>

                                {/* warehouse_and_inventory */}
                                <Tabs.TabPane tab={Resources.warehouse_and_inventory} key="2"  >
                                  <Row gutter={24}>
                                    <Col xs={24} md={24}>
                                      <Form.Item name="available_in_stock" label={Resources.available_in_stock} valuePropName={(selected?.available_in_stock) ? "checked" : ""}   >
                                        <Switch  />
                                      </Form.Item>
                                    </Col>

                                    <Col xs={24} md={12}>
                                      <Form.Item
                                        name="min_purchase_quantity"
                                        label={`${Resources.min_purchase_quantity}`}
                                      >
                                        <Input
                                          type="number"
                                          dir="ltr"
                                        />
                                      </Form.Item>
                                    </Col>
                                    
                                    <Col xs={24} md={12}>
                                      <Form.Item
                                        name="max_purchase_quantity"
                                        label={`${Resources.max_purchase_quantity}`}
                                      >
                                        <Input
                                          type="number"
                                          dir="ltr"
                                        />
                                      </Form.Item>
                                    </Col>
                                    
                                    <Col xs={24} md={12}>
                                      <Form.Item
                                        name="min_mahak_quantity"
                                        label={`${Resources.min_mahak_quantity}`}
                                      >
                                        <Input
                                          type="number"
                                          dir="ltr"
                                        />
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                </Tabs.TabPane>

                                  {/* related_products */}
                                <Tabs.TabPane tab={Resources.related_products} key="3"  >
                                  <Row gutter={24}>

                                  <Col xs={24} md={12}>
                                        <Form.Item
                                          name="sub_list_type"
                                          label={`${Resources.relation_type} `}
                                        >
                                          <Select
                                            options={sub_list_type_options}
                                            // style={{ width: "400px" }}
                                          />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={24}>
                                      <Form.Item
                                        name="related_products"
                                        label={`${Resources.related_products} `}
                                      >
                                        <Select
                                          mode="multiple"
                                          allowClear
                                          showSearch
                                          placeholder="Search and select items"
                                          style={{ minWidth: "300px" }}
                                          filterOption={false} // disable local filtering
                                          onSearch={searchSubProducts} // search triggers API
                                          onChange={setSelectedValues}
                                          options={subProductOptions}
                                          value={selectedValues}
                                          // notFoundContent={fetching ? <Spin size="small" /> : null}
                                        />  
                                      </Form.Item>
                                                        
                                    </Col>

                                  </Row>
                                </Tabs.TabPane>

                                  {/* features */}
                                <Tabs.TabPane tab={Resources.features} key="4"  >
                                  <Row gutter={24}>

                                        <Form.List name="features">
                                                  {(fields, { add, remove }) => (
                                                    <>
                                                      {fields.map(({ key, name, ...restField }) => (
                                                        <Fragment key={key}>
                                                                                <Col xs={10}>
                                                                                    <Form.Item
                                                                                        name={[name, "key"]}
                                                                                        label={Resources.key}
                                                                                        rules={Rules.required}
                                                                                        {...restField}
                                                                                    >
                                                                                        <Input  />
                                                                                    </Form.Item>
                                                                                </Col>
                                                                                <Col xs={10} style={{marginRight:"5px"}}>
                                                                                    <Form.Item
                                                                                        name={[name, "value"]}
                                                                                        label={Resources.value}
                                                                                        rules={Rules.required}
                                                                                        {...restField}
                                                                                    >
                                                                                        <Input  />
                                                                                    </Form.Item>
                                                                                </Col>
                                                                                <Col xs={2}>
                                                                                    <Button
                                                                                        type="link"
                                                                                        onClick={() => remove(name)}
                                                                                        style={{
                                                                                            marginTop: 32,
                                                                                            padding: 0,
                                                                                        }}
                                                                                        block
                                                                                    >
                                                                                        <DeleteOutlined style={{color:"red"}} />
                                                                                    </Button>
                                                                                </Col>
                                                                            </Fragment>
                                                                        ))}
                                                                        <Col xs={24}>
                                                                            <Form.Item>
                                                                                <Button
                                                                                    type="dashed"
                                                                                    onClick={() => add()}
                                                                                    block
                                                                                                                              >
                                                                                    {`${Resources.add}`}
                                                                                </Button>
                                                                            </Form.Item>
                                                                        </Col>
                                                                            </>
                                                                    )}
                                                </Form.List>
                                                        

                                  </Row>
                                </Tabs.TabPane>

                                {/* category  */}
                                <Tabs.TabPane tab={Resources.category} key="5"  >
                                  <Row gutter={24}>
                              

                                    <Col xs={24} md={24}>
                                        <Form.Item
                                          name="category"
                                          label={`${Resources.category} ${Resources.main}`}
                                        >
                                          <Select
                                            filterOption
                                            onChange={this.getSubCategories}
                                            placeholder={Resources.choose}
                                            optionFilterProp="name"
                                            style={{ display: "block" }}
                                            showSearch
                                            allowClear={true}
                                          >
                                            {mainCats.map((cat) => (
                                              <Select.Option key={cat._id} value={cat._id} name={cat.name}>
                                                {cat.name}
                                              </Select.Option>
                                            ))}
                                          </Select>
                                        </Form.Item>
                                    </Col>
                              
                                    <Col xs={24} md={24}>
                                        <Form.Item
                                          shouldUpdate={(prevValues, currentValues) =>
                                            prevValues.category !== currentValues.category
                                          }
                                          noStyle
                                        >
                                          {({ getFieldValue }) => (
                                            <Form.Item
                                              name="subCategory"
                                              label={`${Resources.category} ${Resources.sub}`}
                                            >
                                              <Select
                                                filterOption
                                                placeholder={Resources.choose}
                                                optionFilterProp="name"
                                                style={{ display: "block" }}
                                                allowClear={true}
                                                showSearch
                                              >
                                                {subCats
                                                  // .filter(
                                                  //   (o) =>
                                                  //     parseInt(o.subCategory) ===
                                                  //     getFieldValue("category")
                                                  // )
                                                  .map((cat) => (
                                                    <Select.Option
                                                      key={cat._id}
                                                      value={cat._id}
                                                      name={cat.name}
                                                    >
                                                      {cat.name}
                                                    </Select.Option>
                                                  ))}
                                              </Select>
                                            </Form.Item>
                                          )}
                                        </Form.Item>
                                    </Col>


                                  </Row>
                                </Tabs.TabPane>
                              </Tabs>
                            </Row>

                          </Col>
                          <Col md={8} xs={24} style={{ padding: 20 }} className="custom-row-border">
                                    <h4 className="id card-name" style={{
                                      // background: "#645a5a",
                                      // color: "white",
                                      textAlign: "center",
                                      fontSize: "large"}}>عکس محصول </h4>
                                    <Col xs={24}>
                                    <>
                                      <Upload
                                        {...props}
                                        listType="picture-card"
                                        fileList={fileList}
                                        onPreview={handlePreview}
                                        onChange={handleChange}
                                      >
                                        {fileList.length >= 8 ? null : uploadButton}
                                      </Upload>
                                      {previewImage && (
                                        <Image
                                          wrapperStyle={{ display: 'none' }}
                                          preview={{
                                            visible: previewOpen,
                                            onVisibleChange: visible => setPreviewOpen(visible),
                                            afterOpenChange: visible => !visible && setPreviewImage(''),
                                          }}
                                          src={previewImage}
                                        />
                                      )}
                                    </>
                                    </Col>
                          </Col>
                        </Row>
                      </div>


           
                    </Form> 

                  </div>
              </Modal>
          </Fragment>
      );
  }
};

export default ProductForm;
